import "./Footer.scss";
import React, { useContext } from "react";
import { languages } from "../../languages/languages";
import UserContext from "../../languages/UserContext";
import { Facebook, Instagram, LogoWhite } from "../svg/Svgs";

const Footer = () => {
  const user = useContext(UserContext);

  return (
    <footer>
      <a href="#hero" className="logo-wrap">
        <LogoWhite />
      </a>
      <div className="rights-wrap">
        <span className="rights">® DreamHouse 2020 All rights Reserved</span>
      </div>
      <div className="links-wrap">
        <div className="links-group">
          <span>Regon: 369068704</span>
          <span>NIP: 6772429924</span>
          <span>KRS: 0000711353</span>
        </div>

        <div className="links-group">
          <a className="link" href="#construction">
            {languages[user.lang].Services}
          </a>
          <a className="link" href="#project">
            {languages[user.lang].Portfolio}
          </a>
          <a className="link" href="#mission">
            {languages[user.lang].About}
          </a>
        </div>
      </div>
      <div className="right-foot">
        <a href="#contact"> {languages[user.lang].HireUs}</a>
      </div>
      <div className="social-wrap">
        <a
          target="_blank"
          rel="noreferrer"
          className="thumbnail-social"
          href="https://www.facebook.com/alex.dreamhouse.3"
        >
          <Facebook colorOne="#efefef" />
        </a>
        <a
          href="https://www.instagram.com/dhouseyacom/"
          rel="noreferrer"
          className="thumbnail-social"
          target="_blank"
        >
          <Instagram colorOne="#efefef" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
